import { useState } from 'react';
import { Button, Flex, Input, Text } from '../../../2022-component-library';
import { calibrationConstants } from '../../../helpers/calibration-constants';
import { useCalibration } from '../../../context/calibrationContext';

const ResponsiveManualDistance = ({ updateStep, setActiveTab }) => {
  const {
    updateCalibrationData,
    calibrationData: { pixelDensity, distanceFromScreen },
  } = useCalibration();
  const [patientDistance, setPatientDistance] = useState(distanceFromScreen);
  const { tangent15degrees } = calibrationConstants;

  const submitManualDistance = () => {
    const blindSpotVanishingXDistanceMm = parseInt(patientDistance) * tangent15degrees;

    const newCalibrationData = {
      blindSpotVanishingXDistancePx: blindSpotVanishingXDistanceMm / pixelDensity,
      distanceFromScreen: parseInt(patientDistance),
    };

    updateCalibrationData(newCalibrationData);
  };

  return (
    <Flex column centered fontSize='0.875rem'>
      <Text marginBottom='0.75rem'>{'Enter patient distance (mm)'}</Text>
      <Input
        key='patient-distance-manual-input'
        type='number'
        marginBottom='2rem'
        placeholder='Distance (mm)'
        width='50vw'
        value={patientDistance}
        onChange={(e) => setPatientDistance(e.target.value)}
        onKeyUp={(e) => (e.key === 'Enter' ? e.target.blur() : null)}
      />
      <Flex>
        <Button variant='outlined' marginRight='1rem' maxWidth='200px' onClick={() => updateStep('back')}>
          Back
        </Button>
        <Button
          maxWidth='200px'
          disabled={patientDistance.length < 2}
          onClick={() => {
            submitManualDistance();
            setActiveTab('test');
          }}
        >
          Next
        </Button>
      </Flex>
    </Flex>
  );
};

export default ResponsiveManualDistance;
